var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.83317H6.83334V10.9998C6.83334 11.4582 6.45834 11.8332 6.00001 11.8332C5.54167 11.8332 5.16667 11.4582 5.16667 10.9998V6.83317H1.00001C0.541672 6.83317 0.166672 6.45817 0.166672 5.99984C0.166672 5.5415 0.541672 5.1665 1.00001 5.1665H5.16667V0.999837C5.16667 0.541504 5.54167 0.166504 6.00001 0.166504C6.45834 0.166504 6.83334 0.541504 6.83334 0.999837V5.1665H11C11.4583 5.1665 11.8333 5.5415 11.8333 5.99984C11.8333 6.45817 11.4583 6.83317 11 6.83317Z",
    fill: "#8F9BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ae5b5f7c80d388f6dbd00aa61ce77395.svg";
export { ForwardRef as ReactComponent };